<template lang="pug">
  div
    slot(name='logoutAction')
      ul.nav
        li.nav-item
          a.nav-link(
            @click='logout'
          )
            i.icon-logout
            |  Logout
</template>

<script>
import Messages from '@/utils/notificationsMsg'

export default {
  name: 'Logout',
  methods: {
    logout () {
      if (confirm('Do you want to log out?')) {
        this.$store.dispatch('logout')
          .then(res => {
            this.showNotification(201)
            this.$router.push({ name: 'Login' })
          })
          .catch(error => {
            console.log(error)
            this.showNotification(400)
          })
      }
    },
    showNotification (status) {
      return this.getMessage(Messages.byStatus(status, 'Logout'))
    }
  },
  notifications: {
    getMessage: {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue